export default Object.freeze({
  RAW_DATE_MONTHS: {
    0: 'Jaunuary',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'Jully',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
  },
  CURRENCIES: {
    USD: {
      symbol: '$',
      fullName: 'US Dollar',
      code: 'USD',
    },
    SGD: {
      symbol: 'S$',
      fullName: 'Singapore Dollar',
      code: 'SGD',
    },
    MMK: {
      symbol: 'Kyat',
      fullName: 'Myanmar Kyat',
      code: 'MMK',
    },
  },
});
